import React, { useState, useEffect } from "react";
import { useInput } from "../../hooks/useInput";
import { toast } from "react-toastify";
import updateComorbidityInfo from "../../api/services/updateComorbidityInfo";
import comorbidityListing from "../../api/services/comorbidityListing";
import { HalfCircleSpinner } from "react-epic-spinners";
import { SearchSelect } from "../searchSelect";
import { colourStyles } from "../../data/index";
import { useAllDepartments } from "../../context/allDepartmentContext";
import Popup from "reactjs-popup";
import { recreateComorbidity } from "../../api/services/departmnent-services/recreate";

const UpdateComorbidityInfo = (props) => {
    const [name, bindName] = useInput(props.selectedComorbidity.name);
    const [status, setStatus] = useState(props.selectedComorbidity.status);
    const { departmentListing } = useAllDepartments();
    const [errors, setErrors] = useState({});
    const [showLoader, setShowLoader] = useState(false);
    const [department, setDepartment] = useState(
        props.selectedComorbidity.departments &&
            Object.keys(props.selectedComorbidity.departments)?.length > 0
            ? Object.entries(props.selectedComorbidity.departments).map(
                ([key, value]) => ({ label: value, value: key })
            )
            : []
    );
    const [loader, setLoader] = useState(false);
    const [flag, setFlag] = useState("");

    useEffect(() => {
        setStatus(props.selectedComorbidity.status);
        setDepartment(
            props.selectedComorbidity.departments &&
                Object.keys(props.selectedComorbidity.departments)?.length > 0
                ? Object.entries(props.selectedComorbidity.departments).map(
                    ([key, value]) => ({ label: value, value: key })
                )
                : []
        );
    }, [props.selectedComorbidity]);

    // Handle_Check_Validation
    const checkValidation = () => {
        let errors = {};
        let isValid = true;

        if (!name) {
            isValid = false;
            errors["name"] = "Please enter your name.";
        }
        if (status === null || status === undefined || status === "") {
            isValid = false;
            errors["status"] = "Please select status.";
        }
        if (!department || department?.length < 1) {
            isValid = false;
            errors["department"] = "Please select a Department.";
        }
        setErrors(errors);
        return isValid;
    };

    const handleUpdateComorbidity = (event) => {
        event.preventDefault();

        if (checkValidation()) {
            setShowLoader(true);

            const requestBody = {
                name: name,
                status: status,
                department_ids_update: department.map((dept) => dept.value),
            };

            updateComorbidityInfo
                .updateInfo(props.selectedComorbidity.id, requestBody)
                .then((res) => {
                    if (res.status === 200) {
                        toast.success(res.message);
                        props.handleShowUpdateComorbidity();
                        comorbidityListing
                            .getComorbidities(1)
                            .then((res) => {
                                props.setComorbidityList([...res.data]);
                                props.setPagination(res.meta);
                            })
                            .catch((error) =>
                                toast.error("Error While Fetching The Comorbidity List")
                            );
                    }
                })
                .catch((error) => {
                    setShowLoader(false);
                    if (error?.data?.errors?.id) {
                        setFlag(error.data.message);
                    } else {
                        toast.error(error.data.errors.name[0]);
                    }
                });
        }
    };

    // Restore_Comorbidity
    const restoreComorbidityEntity = () => {
        setLoader(true);
        recreateComorbidity
            .recreate(flag)
            .then((res) => {
                if (res.status === 200) {
                    toast.success(res.message);
                    setLoader(false);
                    comorbidityListing
                        .getComorbidities(1)
                        .then((res) => {
                            props.handleShowUpdateComorbidity();
                            props.setComorbidityList([...res.data]);
                            props.setPagination(res.meta);
                        })
                        .catch((error) =>
                            toast.error("Error While Fetching The Comorbidity List")
                        );
                }
            })
            .catch((error) => {
                setLoader(false);
                toast.error(error.data.message);
            });
    };

    // Handle_Status_Select
    const handleStatusSelect = (event) => {
        setStatus(event.target.value);
    };

    // Handle_Department_Select
    const handleDepartmentSelect = (event) => {
        setDepartment(event);
    };

    return (
        <>
            <form
                className="userForms updateUserForm"
                onSubmit={(event) => handleUpdateComorbidity(event)}
            >
                <article className="widgetWrap">
                    <div className="widgetBody">
                        <div className="dbRow">
                            <div className="dbCol dbColLg75">
                                <div className="dbRow">
                                    <div className="dbCol dbColLg50">
                                        <div className="formRow">
                                            <label className="txtLabel">Name</label>
                                            <div className="inputWrap">
                                                <input
                                                    type="text"
                                                    className={`formControl ${errors.name && "error"}`}
                                                    {...bindName}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dbCol dbColLg50">
                                        <div className="formRow">
                                            <label className="txtLabel">Status</label>
                                            <div className="selectWrap posRelative">
                                                <select
                                                    name="status"
                                                    className={`formControl ${errors.status && "error"}`}
                                                    id="status"
                                                    value={status}
                                                    onChange={handleStatusSelect}
                                                >
                                                    <option value="" defaultValue>
                                                        Select Status
                                                    </option>
                                                    <option value="1">Active</option>
                                                    <option value="0">Inactive</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dbCol dbColLg50">
                                        <div className="formRow">
                                            <label className="txtLabel">Department</label>
                                            <div className="selectWrap posRelative">
                                                <SearchSelect
                                                    name="department"
                                                    className={`basic-multi-select multiSelectDropdown txtRight ${errors.department && "error"
                                                        }`}
                                                    id="department"
                                                    classNamePrefix="select"
                                                    styles={colourStyles}
                                                    options={departmentListing}
                                                    value={department}
                                                    onChange={(event) => {
                                                        handleDepartmentSelect(event);
                                                    }}
                                                    isMulti
                                                    placeholder="Select Department"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="btnWrap">
                            <button
                                onClick={() => {
                                    props.handleShowUpdateComorbidity();
                                }}
                                type="button"
                                className="btn btnWhite"
                            >
                                Cancel
                            </button>
                            <button type="submit" className="btn btnPrimary">
                                Update
                                {showLoader && (
                                    <HalfCircleSpinner
                                        size={18}
                                        style={{
                                            display: "inline-block",
                                            marginLeft: "7px",
                                            position: "relative",
                                            top: "2px",
                                        }}
                                    />
                                )}
                            </button>
                        </div>
                    </div>
                </article>
            </form>

            {/* Restore_Comorbidity_Popup */}
            <Popup
                className="restoreDepartmentModal deleteUserModal"
                open={flag !== ""}
                onClose={() => setFlag("")}
            >
                <div className="modal textCenter">
                    <p>
                        Comorbidity exists with the same name. Do you want to restore it?
                    </p>
                    <div className="btnWrap">
                        <button
                            onClick={() => setFlag("")}
                            type="button"
                            className="btn btnSecondary"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={restoreComorbidityEntity}
                            type="button"
                            className="btn btnPrimary"
                            disabled={loader}
                        >
                            Restore
                            {loader && (
                                <HalfCircleSpinner
                                    size={18}
                                    style={{
                                        display: "inline-block",
                                        marginLeft: "7px",
                                        position: "relative",
                                        top: "2px",
                                    }}
                                />
                            )}
                        </button>
                    </div>
                </div>
            </Popup>
        </>
    );
};

export default UpdateComorbidityInfo;
